import { useTranslation } from 'next-i18next';
import { UploadIcon } from '@/icons';
import { Button } from '@/ui_v3';
export const ImageInputButton = ({
  onClick
}: {
  onClick: () => void;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Button variant="contained" intent="strong" leftSlot={<UploadIcon size="md" />} size="lg" onClick={onClick} data-sentry-element="Button" data-sentry-component="ImageInputButton" data-sentry-source-file="ImageInputButton.tsx">
      {t('image.uploadTab.button')}
    </Button>;
};